import * as Yup from "yup"

const phoneRegex = /^(^\+62\s?|^0)(\d{3,4}-?){2}\d{3,4}$/

export const initialRegisterValues = {
    firstName: "",
    lastName: "",
    companyName: "",
    phoneNumber: "",
    email: "",
    address: "",
    city: "",
    country: "",
    subject: "",
    message: "",
    salutations: "",
    recaptcha: "",
}

export const YupRegisterValidation = Yup.object({
    email: Yup.string().email("Invalid email format").required("Email required"),
    firstName: Yup.string().required("First name required"),
    lastName: Yup.string().required("Last name required"),
    companyName: Yup.string().required("Company name required"),
    subject: Yup.string().required("Subject required"),
    message: Yup.string().required("Message required"),
    phoneNumber: Yup.string()
        .required("Mobile number required")
        .matches(phoneRegex, "Invalid mobile number"),
    recaptcha: Yup.string().required("Please verify that you are not a robot"),
})
